/** Ángulos de fotografía requeridos según el tipo de producto. */
export type PhotoAngle =
  | 'front'
  | 'lateral_exterior'
  | 'lateral_interior'
  | 'front_45'
  | 'back'
  | 'outsole';

/** Ángulo de subida opcional; cada POST agrega una imagen (no reemplaza). */
export type PhotoExtraUploadAngle = 'extra';

export type PhotoUploadAngle = PhotoAngle | PhotoExtraUploadAngle;

export const PHOTO_ANGLE_LABELS: Record<PhotoAngle, string> = {
  front: 'Vista frontal',
  lateral_exterior: 'Lateral exterior',
  lateral_interior: 'Lateral interior',
  front_45: 'Vista frontal 45°',
  back: 'Vista trasera',
  outsole: 'Suela',
};

export const PHOTO_EXTRA_ANGLE_LABEL = 'Foto adicional';

/** Productos nuevos solo requieren la foto frontal. */
export const NEW_ITEM_ANGLES: PhotoAngle[] = ['front'];

/** Productos usados requieren 5 ángulos de condición. */
export const USED_ITEM_ANGLES: PhotoAngle[] = [
  'lateral_exterior',
  'lateral_interior',
  'front_45',
  'back',
  'outsole',
];

export interface PhotoQueueSlot {
  angle: PhotoAngle;
  /** null si aún no se ha subido la foto para este ángulo. */
  url: string | null;
}

export interface PhotoQueueExtraPhoto {
  id: number;
  url: string;
}

export interface PhotoQueueItem {
  id: number;
  artId: string | null;
  title: string;
  consignorName: string;
  sizeCm: string | null;
  /** true = producto nuevo (solo requiere 1 foto); false = producto usado (5 fotos). */
  isNew: boolean;
  /**
   * Solo aplica a producto usado. Si true, el personal eximió el requisito de 5 ángulos
   * (PATCH photo-requirements-waived). El ítem puede salir de la cola sin 5 fotos.
   */
  photoRequirementsWaived: boolean;
  /** Slots pre-poblados con todos los ángulos requeridos; url=null indica pendiente. */
  photos: PhotoQueueSlot[];
  /** Fotos opcionales adicionales (no cuentan para uploadedCount / totalRequired). */
  extraPhotos: PhotoQueueExtraPhoto[];
  uploadedCount: number;
  totalRequired: number;
}

export type PhotoQueueFilter = 'all' | 'new' | 'used';

export interface PhotoQueueSummary {
  totalPending: number;
  newPending: number;
  usedPending: number;
}

export interface PhotoQueueListPayload {
  items: PhotoQueueItem[];
  total: number;
  page: number;
  pageSize: number;
  summary: PhotoQueueSummary | null;
}
